export default __webpack_public_path__ + "static/media/limpopo-uni-logo.9b808068.jpeg";